import { usePermissions } from "components/context/permissionsContext";

export const useServiceRequestPermission = () => {
  const { userPermissions } = usePermissions();

  const hasServiceGetPermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "ServiceRequest" &&
      item.action === "GetServiceRequest" &&
      item.hasPermission
  );
  const hasConvertToPermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "ServiceRequest" &&
      item.action === "ConvertToEntity" &&
      item.hasPermission
  );
  const hasGetJobRequestGetPermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "ServiceRequest" &&
      item.action === "GetJobRequest" &&
      item.hasPermission
  );
  const hasStatusUpdatePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "ServiceRequest" &&
      item.action === "UpdateStatus" &&
      item.hasPermission
  );
  const hasRequestSearchPermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "ServiceRequest" &&
      item.action === "Search" &&
      item.hasPermission
  );
  const hasPropertyAreaGetPermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "ServiceRequest" &&
      item.action === "GetPropertyArea" &&
      item.hasPermission
  );
  const hasPropertyAreaDeletePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "ServiceRequest" &&
      item.action === "DeletePropertyArea" &&
      item.hasPermission
  );
  const hasPropertyAreaSavePermission = userPermissions.some(
    (item) =>
      item.module === "ServiceRequest" &&
      item.controller === "ServiceRequest" &&
      item.action === "SavePropertyArea" &&
      item.hasPermission
  );

  const ServiceRequestPermissionProps = {
    hasServiceGetPermission,
    hasConvertToPermission,
    hasGetJobRequestGetPermission,
    hasStatusUpdatePermission,
    hasRequestSearchPermission,
    hasPropertyAreaSavePermission,
    hasPropertyAreaGetPermission,
    hasPropertyAreaDeletePermission,
  };

  return {
    ServiceRequestPermissionProps,
  };
};
